// extracted by css-extract-rspack-plugin
var _1 = "qx";
var _2 = "qz";
var _3 = "ax";
export { _1 as "ctaComponent", _2 as "mgmMainPageComponent", _3 as "standardContainerV2" }
